var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBaht(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5.5,
    height: 12.482,
    viewBox: "0 0 5.5 12.482",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.458,0v2.1h-1.2V0L-2.739,0V-8.25H-.746v-2.127h1.2V-8.25H.935a1.758,1.758,0,0,1,1.289.537,1.758,1.758,0,0,1,.537,1.289v.473A1.751,1.751,0,0,1,2.316-4.69a2.16,2.16,0,0,1-1.381.565,1.677,1.677,0,0,1,1.377.548A1.956,1.956,0,0,1,2.761-2.3v.473A1.743,1.743,0,0,1,2.221-.544,1.8,1.8,0,0,1,.935,0ZM-.913-.924H.011a.907.907,0,0,0,.651-.262.854.854,0,0,0,.273-.64V-2.75a.817.817,0,0,0-.924-.924H-.913Zm0-3.652H.011a.889.889,0,0,0,.651-.273A.889.889,0,0,0,.935-5.5v-.924a.857.857,0,0,0-.269-.645.911.911,0,0,0-.655-.258H-.913Z",
    transform: "translate(2.739 10.377)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaht);
export default __webpack_public_path__ + "static/media/baht.bb18090c6146bd47e60e9f95ad434faf.svg";
export { ForwardRef as ReactComponent };